export default __webpack_public_path__ + "static/media/16-KanagawaDonut.b6608d9e.png";